import { useTranslation } from 'react-i18next';
import { useProfile } from '@contexts/ProfileContext';
import { Text, TextSize, TextType, TextWeight } from '@components/Text';
import { Grid, Column, Row } from '@components/Grid';
import Box from '@components/Box';
import { formatSumWithCurrency } from '@utils/formatValues';
import styles from './PickupPriceModal.module.scss';

type PickupPriceModalProps = {
  factPrice: number,
  weightPrice: number,
}

const PickupPriceModal: React.FC<PickupPriceModalProps> = ({
  factPrice,
  weightPrice,
}): React.ReactElement => {
  const { t } = useTranslation();
  const { account } = useProfile();
  const variableCurrency: string = account?.region === 'TR' ? '$' : '¥';

  return (
    <Grid>
      <Row>
        <Column phone={12}>
          <Box pb={4}>
            <Text type={TextType.H1}>
              {t("pickUp.pickUpPrice.title")}
            </Text>
          </Box>
        </Column>
      </Row>

      <Box pb={1}>
        <Column phone={6}>
          <Text size={TextSize.S}>
            {t("pickUp.pickUpPrice.line1")}
          </Text>
        </Column>
        <Column phone={6}>
          <Text size={TextSize.S} weight={TextWeight.SEMIBOLD}>
            {t("pickUp.pickUpPrice.line1-value", { value: formatSumWithCurrency(weightPrice, variableCurrency) })}
          </Text>
        </Column>
      </Box>

      <Box pb={5}>
        <Column phone={6}>
          <Text size={TextSize.S}>
            {t("pickUp.pickUpPrice.line2")}
          </Text>
        </Column>
        <Column phone={6}>
          <Text size={TextSize.S} weight={TextWeight.SEMIBOLD}>
            {formatSumWithCurrency(factPrice, variableCurrency)}
          </Text>
        </Column>
      </Box>

      <Box p={3} mb={5} className={styles.formula}>
        <Column phone={12}>
          <Text>
            <Text weight={TextWeight.BOLD}>
              {t("pickUp.pickUpPrice.formula1")}
            </Text>
            {t("pickUp.pickUpPrice.formula2")}
          </Text>
        </Column>
      </Box>

      <Box pb={1}>
        <Column phone={12}>
          <Text weight={TextWeight.BOLD} size={TextSize.S}>
            {t("pickUp.pickUpPrice.exampleTitle")}
          </Text>
        </Column>
      </Box>
      <Box pb={1}>
        <Column phone={6}>
          <Text size={TextSize.S}>
            {t("pickUp.pickUpPrice.example")}
          </Text>
        </Column>
      </Box>
      <Box>
        <Column phone={6}>
          <Text size={TextSize.S}>
            {`(${weightPrice}×(3×2))+${factPrice}=${formatSumWithCurrency(factPrice + weightPrice * 6, variableCurrency)}`}
          </Text>
        </Column>
      </Box>
    </Grid>
  );
};

export default PickupPriceModal;
